/* Water Wizard's explicit specialist request. The existing F1 form creates a Help Desk ticket.
 * Public endpoint only; no token, automatic capture, marketing subscription or Shopify fallback.
 * The submitted packet is exactly the privacy-reviewed contact[Quiz answers] field, without truncation.
 */
(function (win, doc) {
  'use strict';
  if (win.CQWizContact) return;
  const ROOT = '[data-cqq-quiz="wizard"]', FORM = 'dialog[data-cqq-contact] form';
  const PRIVACY = 'We use these details only to reply about your water.';
  const states = new WeakMap(), TIMEOUT = 15000;
  const value = (form, name) => { const el = form.elements.namedItem(name); return el ? String(el.value || '') : ''; };
  const field = (name, v, type) => ({objectTypeId: type || '0-1', name, value: String(v)});
  function config(root) {
    const d = root.dataset;
    if (!/^\d+$/.test(d.cqwContactPortal || '') || !/^[a-f\d-]{36}$/i.test(d.cqwContactReview || '') || d.cqwContactHost !== 'api-na2.hsforms.com') return null;
    return 'https://' + d.cqwContactHost + '/submissions/v3/integration/submit/' + d.cqwContactPortal + '/' + d.cqwContactReview;
  }
  function reference() {
    if (win.crypto && typeof win.crypto.randomUUID === 'function') return 'WZ-' + win.crypto.randomUUID();
    return 'WZ-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  function buildBody(form, ref) {
    const name = value(form, 'contact[name]').trim().split(/\s+/).filter(Boolean);
    const email = value(form, 'contact[email]').trim(), packet = value(form, 'contact[Quiz answers]');
    if (!name.length || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) throw new Error('Enter your name and a valid email so our team can reply.');
    if (!packet.trim()) throw new Error('Your plan is still loading. Close this window and open the review again.');
    const subject = value(form, 'contact[subject]').trim() || 'Water Wizard: specialist review';
    const note = value(form, 'contact[body]');
    const page = win.location.origin + win.location.pathname;
    const content = (note.trim() ? note + '\n\n' : '') + packet + '\n\nPage: ' + page + '\nRequest reference: ' + ref;
    const fields = [field('email', email), field('firstname', name[0]), field('lastname', name.slice(1).join(' ')), field('subject', subject, '0-5'), field('content', content, '0-5')];
    const phone = value(form, 'contact[phone]').trim(); if (phone) fields.push(field('phone', phone));
    return {fields, context: {pageUri: page, pageName: doc.title || 'Water Wizard'},
      legalConsentOptions: {legitimateInterest: {value: true, subscriptionTypeId: 935551697, legalBasis: 'LEAD', text: PRIVACY}}};
  }
  function statusNode(form) {
    let node = form.querySelector('[data-cqw-contact-status]');
    if (!node) {
      node = doc.createElement('p'); node.className = 'cqv-form-status'; node.dataset.cqwContactStatus = '';
      node.setAttribute('role', 'status'); node.setAttribute('aria-live', 'polite'); node.tabIndex = -1;
      const btn = form.querySelector('[type="submit"]'); if (btn) btn.before(node); else form.appendChild(node);
    }
    return node;
  }
  function announce(root, form, state) {
    root.dispatchEvent(new win.CustomEvent('cq:wizard:contact-status', {bubbles: true, detail: {status: state.status, reference: state.ref, form, snapshot: state.snapshot}}));
  }
  function snapshot(form, record) {
    const box = form.querySelector('[data-cqw-send]'), cb = form.querySelector('[data-cqw-send-values]');
    return {record, values: Array.from(form.elements).filter(el => el.name).map(el => ({name: el.name, value: el.value})),
      reportValuesIncluded: cb ? cb.checked : null, full: box && box.cqwFull, lean: box && box.cqwLean,
      preview: box && box.querySelector('[data-cqw-send-preview]').textContent};
  }
  function restore(form) {
    const state = states.get(form), draft = state && (state.status === 'pending' ? state.snapshot : state.status === 'error' ? state.draft : null);
    if (!draft) return false;
    draft.values.forEach(item => { const el = form.elements.namedItem(item.name); if (el) el.value = item.value; });
    const box = form.querySelector('[data-cqw-send]'), cb = form.querySelector('[data-cqw-send-values]');
    if (cb) cb.checked = draft.reportValuesIncluded;
    if (box) {
      box.cqwFull = draft.full; box.cqwLean = draft.lean;
      box.querySelector('[data-cqw-send-preview]').textContent = draft.preview;
      let note = box.querySelector('[data-cqw-contact-draft-note]');
      if (!note) { note = doc.createElement('p'); note.dataset.cqwContactDraftNote = ''; box.appendChild(note); }
      note.textContent = state.status === 'pending' ? 'This is the plan already being sent. Changes made after sending are not included.' : 'Your earlier request is still here. Review it before retrying. Changes made since then are not included.';
      let fresh = box.querySelector('[data-cqw-contact-new-request]');
      if (!fresh && state.status === 'error') {
        fresh = doc.createElement('button'); fresh.type = 'button'; fresh.className = 'cqv-text-btn'; fresh.dataset.cqwContactNewRequest = '';
        fresh.textContent = 'Start a new request with my current plan';
        fresh.addEventListener('click', () => {
          if (states.get(form)?.status === 'pending') return;
          const opener = form.closest(ROOT).querySelector('.cqw-result-page [data-cqq-do="contact"]'); if (!opener) return;
          const identity = ['contact[name]', 'contact[email]', 'contact[phone]'].map(name => ({name, value: value(form, name)}));
          form.reset(); identity.forEach(item => { const el = form.elements.namedItem(item.name); if (el) el.value = item.value; });
          form.closest('dialog').close(); opener.click();
        });
        box.appendChild(fresh);
      }
      if (fresh) fresh.hidden = state.status !== 'error';
    }
    return true;
  }
  function freeze(form, state, active) {
    if (active) {
      state.controls = Array.from(form.querySelectorAll('input,textarea,select,button')).map(el => [el, el.disabled]);
      state.controls.forEach(([el]) => { el.disabled = true; }); form.setAttribute('aria-busy', 'true');
    } else {
      (state.controls || []).forEach(([el, disabled]) => { el.disabled = disabled; }); state.controls = [];
      form.removeAttribute('aria-busy');
    }
  }
  function feedback(form, state, text) {
    const node = statusNode(form); node.textContent = text; node.hidden = false;
    node.dataset.state = state.status;
    try { node.focus({preventScroll: false}); } catch (_) {}
  }
  function failure(response, data) {
    const errors = JSON.stringify(data && data.errors || []);
    if (response && response.status === 400 && /INVALID_EMAIL|BLOCKED_EMAIL/i.test(errors)) return 'That email address was not accepted. Check it and try again.';
    if (response && response.status === 429) return 'The request service is busy. Please wait a moment, then try again.';
    if (response && response.status >= 400 && response.status < 500) return 'The request service could not accept these details. Your message and plan are still here. Check your details, try again, or call 1-800-934-0051.';
    return 'We could not confirm whether your request arrived. Your details are still here. Try again, or call 1-800-934-0051. A retry may send a duplicate.';
  }
  async function submit(root, form) {
    const old = states.get(form);
    if (old && (old.status === 'pending' || old.status === 'accepted')) return;
    const state = old || {ref: reference(), status: 'idle'}; states.set(form, state);
    const url = config(root), hp = form.querySelector('[data-cqq-hp]');
    let body;
    try {
      if (!url) throw new Error('Online requests are unavailable. Please call 1-800-934-0051 and keep your saved plan.');
      if (hp && hp.value) throw new Error('We could not send this request. Please call 1-800-934-0051 for help.');
      body = buildBody(form, state.ref);
    } catch (error) { state.status = 'error'; feedback(form, state, error.message); return; }
    const btn = form.querySelector('[type="submit"]');
    // Receipt metadata belongs to the reviewed request, even if the visitor changes the quiz while it is in flight.
    const record = state.draft ? state.draft.record : win.CQWizCapture && win.CQWizCapture.latest();
    state.snapshot = snapshot(form, record); state.draft = state.snapshot;
    state.status = 'pending'; freeze(form, state, true);
    if (btn) btn.textContent = 'Sending your plan...';
    feedback(form, state, 'Sending your review request. Please wait for confirmation.'); announce(root, form, state);
    const controller = typeof win.AbortController === 'function' ? new win.AbortController() : null;
    let timer, response, data;
    try {
      // The explicit timeout also settles if a browser extension ignores AbortController.
      const timedOut = new Promise((_, reject) => { timer = win.setTimeout(() => { if (controller) controller.abort(); reject(new Error('timeout')); }, TIMEOUT); });
      const request = win.fetch(url, {method: 'POST', mode: 'cors', credentials: 'omit', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body), signal: controller ? controller.signal : undefined})
        .then(async res => { response = res; try { data = await res.json(); } catch (_) {} return res; });
      await Promise.race([request, timedOut]);
      if (!response.ok || response.status !== 200 || !data || typeof data !== 'object' || Array.isArray(data) || data.errors && data.errors.length) throw new Error('not-accepted');
      state.status = 'accepted'; freeze(form, state, false);
      // Use the shared sent node so opening a fresh contact request resets the form normally.
      const dialog = form.closest('dialog'), sent = dialog.querySelector('[data-cqq-hs-sent]');
      if (sent) {
        sent.textContent = 'Your review request was received. A Crystal Quest specialist will follow up by email. Request reference: ' + state.ref;
        sent.hidden = false; form.hidden = true; try { sent.focus(); } catch (_) {}
      } else { feedback(form, state, 'Your review request was received. A specialist will follow up by email. Request reference: ' + state.ref); if (btn) btn.disabled = true; }
      announce(root, form, state);
    } catch (_) {
      state.status = 'error'; freeze(form, state, false);
      if (btn) btn.textContent = 'Try sending again';
      feedback(form, state, failure(response, data) + '\nRequest reference: ' + state.ref); announce(root, form, state);
      if (btn && typeof btn.scrollIntoView === 'function') btn.scrollIntoView({block: 'nearest'});
    } finally { win.clearTimeout(timer); }
  }
  function mount(root) {
    if (!root || root.dataset.cqwContactBound) return;
    root.dataset.cqwContactBound = '1';
    // An ancestor's capture listener runs before the shared dialog sender and Shopify's form hooks.
    // Stop the original event on every path, including validation failure and duplicate clicks.
    root.addEventListener('submit', event => {
      const form = event.target;
      if (!form.matches || !form.matches(FORM)) return;
      event.preventDefault(); event.stopImmediatePropagation(); submit(root, form);
    }, true);
    const form = root.querySelector(FORM);
    if (form) {
      // R1 gate (2026-10-16): on short screens the Send button stays in view with this consent line above it
      // (cq-wiz-quiz.css shows it only at 600 px tall or less, where the dialog body scrolls)
      const send = form.querySelector('[type="submit"]');
      if (send && !form.querySelector('[data-cqw-send-consent]')) {
        const consent = doc.createElement('p'); consent.className = 'cqw-send-consent'; consent.dataset.cqwSendConsent = '';
        consent.textContent = 'Nothing is sent until you press Send.'; send.before(consent);
      }
      const edited = () => { const state = states.get(form); if (state && state.status === 'error' && state.snapshot) state.draft = snapshot(form, state.snapshot.record); };
      form.addEventListener('input', edited); form.addEventListener('change', edited);
      root.addEventListener('cqq:event', event => {
        if (event.detail && event.detail.name === 'cq_quiz_retake' && states.get(form)?.status !== 'pending') form.reset();
      });
      form.addEventListener('reset', event => {
      const state = states.get(form); if (state && state.status === 'pending') { event.preventDefault(); return; }
      states.delete(form); const node = form.querySelector('[data-cqw-contact-status]'); if (node) node.hidden = true;
      const note = form.querySelector('[data-cqw-contact-draft-note]'); if (note) note.remove();
      const fresh = form.querySelector('[data-cqw-contact-new-request]'); if (fresh) fresh.remove();
      const btn = form.querySelector('[type="submit"]'); if (btn) { btn.disabled = false; btn.textContent = 'Send my plan'; }
      });
    }
  }
  function init() { doc.querySelectorAll(ROOT).forEach(mount); }
  win.CQWizContact = {mount, buildBody, restore, state: form => { const s = states.get(form); return s ? {status: s.status, reference: s.ref} : null; }};
  init(); if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init, {once: true});
  doc.addEventListener('shopify:section:load', init);
})(window, document);
